









import { Component, Vue } from 'vue-property-decorator';
import { PermissionModule } from '@/store/modules/permission';
import { RouteConfig } from 'vue-router';
import MenuItem from './menuItem.vue';
import SubMenu from './subMenu.vue';
import { deepClone } from '@/utils/deepClone';

@Component({
  components: {
    MenuItem,
    SubMenu,
  },
})
export default class MenuList extends Vue {
  private menuData: RouteConfig[] = [];
  get selectedKeys(): string[] {
    return this.$route.meta?.activeMenu || [];
  }
  private created() {
    this.menuData = this.generateMenuData(PermissionModule.routes);
  }
  private generateMenuData(routes: RouteConfig[]) {
    const menus: RouteConfig[] = [];
    routes.forEach((route: RouteConfig) => {
      if (!route.meta || !route.meta.hidden) {
        const newRoute = deepClone(route);
        const alwaysShowRootMenu = this.alwaysShowRootMenu(newRoute);
        const childRoute = this.theOnlyChild(newRoute);
        if (!alwaysShowRootMenu && childRoute && !childRoute.children) {
          menus.push(childRoute);
        } else {
          newRoute.children = this.generateMenuData(route.children!);
          if (alwaysShowRootMenu || newRoute.children.length > 0) {
            menus.push(newRoute);
          }
        }
      }
    });
    return menus;
  }
  private alwaysShowRootMenu(route: RouteConfig): boolean {
    if (route.meta && route.meta.alwaysShow) {
      return true;
    }
    return false;
  }
  private showingChildNumber(route: RouteConfig): number {
    if (route.children) {
      const showingChildren = route.children.filter((item) => {
        if (item.meta && item.meta.hidden) {
          return false;
        } else {
          return true;
        }
      });
      return showingChildren.length;
    }
    return 0;
  }
  private theOnlyChild(route: RouteConfig) {
    if (this.showingChildNumber(route) > 1) {
      return null;
    }
    if (route.children) {
      for (const child of route.children) {
        if (!child.meta || !child.meta.hidden) {
          return child;
        }
      }
    }
    return {...route};
  }
}
